import { ConvertAPI } from 'convertapi';





export const fileToPng = async(file) => {
  const convertApi = new ConvertAPI('PS1qixofRSnkJEgW');
  // let convertApi = convertApi.auth({ secret: "Q2IvZQi4AznrWjw4" });
  // let params = convertApi.createParams();
  // params.add("File", file);
  let result = await convertApi.convert("ppt", "png", {"File": file});
   console.log("result-------------------------------------------------------------------------------------------------images",result)
};
